/**
 * Generates a concept filter based on the provided properties.
 * @param {Object} props The properties object, containing conceptList, selectedLocalConcepts, conceptTypeDay, and selectedPageSize.
 * @returns {Object} The concept filter configuration.
 */
export function getConceptFilter(props) {
    let conceptFilter;

    if (props.conceptList) {
        conceptFilter = {
            type: "concept_list",
            concept_list_id: props.conceptList,
        };
    } else if (
        props.selectedLocalConcepts &&
        props.selectedLocalConcepts.length > 0
    ) {
        const specifiedConcepts = props.selectedLocalConcepts.map(
            (concept) => ({
                texts: [concept],
            })
        );
        conceptFilter = { type: "specified", concepts: specifiedConcepts };
    } else if (props.conceptTypeDay === "suggested") {
        conceptFilter = { type: props.conceptTypeDay };
    } else {
        conceptFilter = {
            type: props.conceptTypeDay ? props.conceptTypeDay : "top",
            limit: props.selectedPageSize
                ? Number(props.selectedPageSize)
                : undefined,
        };
    }

    return conceptFilter;
}
